<template>
  <div class="row">
    <div class="col-sm-6 box-material-extra-b" v-if="resumos.length > 0">
      <div class="header-box-material-extra">
        <h4>Resumos</h4>
        <hr class="hr-header">
      </div>
      <div class="boxes-material-sala">
        <div v-for="(resumo, index) in resumos">
          <div class="resumo">
            <div>
              <img :src="obterCaminhoCompleto('resumo.png', 'img')"/>
                <div>
                  <p>{{ resumo.titulo }}</p>
                </div>
            </div>
            <div class="justify-content-end">
              <a :href="obterCaminhoCompleto(resumo.url, 'apostila-web')" class="btn btn-secondary" @click="registrarDownload(resumo)" target="_blank">
                <i class="fas fa-arrow-alt-circle-down mr-1"></i> Abrir
              </a>
            </div>
          </div>
          <hr v-if="index != resumos.length - 1">
        </div>
      </div>
    </div>
    <div class="col-sm-6 box-material-extra-b" v-if="referencias.length > 0">
      <div class="header-box-material-extra">
        <h4>Referências</h4>
        <hr class="hr-header">
      </div>
      <div class="boxes-material-sala">
        <div v-for="(referencia, index) in referencias">
          <div class="referencia">
            <div>
              <img :src="obterCaminhoCompleto('livro.png', 'img')"/>
                <div>
                  <p>{{ referencia.referencia }}</p>
                </div>
            </div>
            <div class="justify-content-end">
              <a :href="referencia.url" class="btn btn-secondary" target="_blank">
                <i class="fas fa-external-link-square-alt mr-1"></i> Ver online
              </a>
            </div>
          </div>
          <hr v-if="index != referencias.length - 1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUtils from '@/core/utils/image-utils'
import ResumoAPI from '@/api/resumo-api'

export default {
  name: 'MateriaisExtras',
  props: {
    resumos: Array,
    referencias: Array
  },
  methods: {
    obterCaminhoCompleto: function (resumo, pasta) {
      return ImageUtils.obterUrlCompletaImagem(`${resumo}`, `${pasta}/`)
    },

    registrarDownload: function (resumo) {
      ResumoAPI.registrarDownload(resumo.id)
    }
  }
}
</script>

<style scoped>

</style>
